import { client } from '../../utils/axios-utils';

const url = `${process.env.REACT_APP_CORPORATECHAT_API_URL}/${process.env.REACT_APP_API_URI}/messages`;

/** O endpoint de envio passou a aceitar apenas multipart/form-data, então o envio é
 *  sempre multipart, com ou sem anexo.
 *  O `Content-Type` NÃO é informado de propósito: o adapter do axios 0.19 remove o
 *  header quando o corpo é FormData e deixa o browser gerar o boundary. Passar um
 *  `headers` aqui também substituiria o objeto inteiro do `client()` e derrubaria o
 *  Authorization (o spread de `axios-utils` é raso).
 */
const buildSendMessagesFormData = ({ usersDestination, messages, files }) => {
	const formData = new FormData();

	(usersDestination || []).forEach(userId => {
		formData.append('UsersDestination', String(userId));
	});

	(messages || []).forEach((message, index) => {
		formData.append(`Messages[${index}].Order`, String(message.order));
		formData.append(`Messages[${index}].MessageText`, message.messageText || '');
		formData.append(`Messages[${index}].ExternalReference`, message.externalReference);
	});

	(files || []).forEach(file => {
		formData.append('Files', file);
	});

	return formData;
}

const messagesService = {
	postMessagesSend: (params) => {
		return new Promise((resolve, reject) => {
			return client()
				.post(`${url}/send`, buildSendMessagesFormData(params))
				.then((res) => resolve(res.data))
				.catch((error) => reject(error));
		});
	},
	getMessageById: (messageId) => {
		return new Promise((resolve, reject) => {
			return client()
				.get(`${url}/${messageId}`)
				.then((res) => resolve(res.data))
				.catch((error) => reject(error));
		});
	},
	getMessagesByUser: (messageId, params) => {
		return new Promise((resolve, reject) => {
			return client()
				.get(`${url}/byuser/${messageId}`, { params })
				.then((res) => resolve(res.data))
				.catch((error) => reject(error));
		});
	},
	deleteMessages: (messageId) => {
		return new Promise((resolve, reject) => {
			return client()
				.delete(`${url}/${messageId}`)
				.then((res) => resolve(res.data))
				.catch((error) => reject(error));
		});

	},
	putMessagesSetAsRead: (messageId) => {
		return new Promise((resolve, reject) => {
			return client()
				.put(`${url}/setasread/${messageId}`)
				.then((res) => resolve(res.data))
				.catch((error) => reject(error));
		});

	},
	putMessagesConversationIdSetAsRead: (conversationId) => {
		return new Promise((resolve, reject) => {
			return client()
				.put(`${url}/${conversationId}/setallread/`)
				.then((res) => resolve(res.data))
				.catch((error) => reject(error));
		});

	}
};

export { buildSendMessagesFormData };
export default messagesService;
